import dayGridPlugin from "@fullcalendar/daygrid";
import FullCalendar from "@fullcalendar/react";
import { styled } from "@mui/system";

const PageContainer = styled("div")(() => ({
  backgroundColor: "#fafafa",
  height: "100%",
}));
const CalendarContainer = styled("div")(({ theme }) => ({
  height: "100%",
  margin: "auto",
  [theme.breakpoints.down("xl")]: {
    padding: 0,
  },
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(1),
  },
}));

export default function Calendar() {
  return (
    <PageContainer>
      <CalendarContainer>
        <FullCalendar height="100%" plugins={[dayGridPlugin]} initialView="dayGridMonth" events={[]} />
      </CalendarContainer>
    </PageContainer>
  );
}
